import React from 'react'
import styled from 'styled-components'

import { Button, Separator as Separator_, Typography } from '@blade/ui-kit'
import { RectangleNetworkBackground } from '@root/shared/ui/background/rectangle-network'

import type { InfoMessageProps } from './info-message'

export const InfoMessageBold: React.FC<InfoMessageProps> = ({
  className,
  icon,
  onRetry,
  hint,
  title,
  description,
  retryText,
  children,
  withBackground,
}) => {
  return (
    <Root className={className} $withBackground={withBackground}>
      <IconWrapper>
        {icon ? React.cloneElement(icon, { size: 16 }) : undefined}
      </IconWrapper>
      <Title>{title}</Title>
      <Separator />
      {children ? undefined : <Description>{description}</Description>}
      {onRetry ? (
        <ButtonAlt
          size="xs"
          radius="rounded"
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            onRetry()
          }}
          variant="solid"
          color="primary"
        >
          {retryText}
        </ButtonAlt>
      ) : undefined}

      {children}
      {hint ? <Hint>{hint}</Hint> : undefined}
    </Root>
  )
}

const Root = styled.div<{ $withBackground: boolean | undefined }>`
  ${({ $withBackground }) =>
    $withBackground ? RectangleNetworkBackground : undefined}

  color: var(--textA-10);
  display: grid;

  justify-items: center;
  min-width: 230px;

  place-content: center;
  gap: 10px;
  border-radius: 12px;
  overflow: hidden;
`

const IconWrapper = styled.div`
  background: var(--background-4);
  color: var(--text-12);

  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: grid;
  place-content: center;
`

const Title = styled(Typography).attrs({
  variant: 'body2-bold',
  component: 'div',
})`
  color: var(--text-12);
  text-align: center;
`

const Description = styled(Typography).attrs({
  variant: 'body5-medium',
})`
  color: var(--text-8);
  text-align: center;
  line-height: 16px;
`

const Separator = styled(Separator_)`
  width: 100%;
  min-width: 150px;
`

const ButtonAlt = styled(Button)`
  border-radius: 6px;
`

const Hint = styled(Typography).attrs({
  variant: 'body2-regular',
  component: 'div',
})`
  color: var(--text-12);
  text-align: center;
`
